import { FiEdit, FiInfo, FiTrash2, FiSettings } from "react-icons/fi";
import {
  scenarioExe,
  scenarioListWidget,
  scenarioWidgetExtraList,
} from "../../api";
import Cookies from "js-cookie";
import { useState } from "react";
import { Alert } from "../Alert";
import { AddScenario } from "./AddScenario";
import { ModalComp } from "../ModalComp";
import { useReducer } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
const ScenariosModal = ({ scenario, closeModal }) => {
  const { t } = useTranslation();
  const { title, icon, uid } = scenario;
  const token = Cookies.get("token");
  const [openAddScenarioModal, setOpenAddScenarioModal] = useState(false);
  const [submitScenarioEdit, setSubmitScenarioEdit] = useState(false);
  const toggleAddScenario = () => {
    setOpenAddScenarioModal(!openAddScenarioModal);
    setSubmitScenarioEdit(!submitScenarioEdit);
  };
  const [scenarioCommand, setScenarioCommand] = useState([]);
  const [widgetIndex, setWidgetIndex] = useState("");
  const toggleAlert = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: false,
    }));
  };
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
    question: false,
    request: "",
  });
  const handleScenarioExe = () => {
    var data = new FormData();
    data.append("scenario_id", uid);
    window.addEventListener("online", function () {
      setShowAlert((prevState) => ({
        ...prevState,
        show: true,
        message: "you are connecting to the Internet",
        type: "Success",
      }));
      setTimeout(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: false,
        }));
      }, 5000);
    });
    window.addEventListener("offline", function () {
      setShowAlert((prevState) => ({
        ...prevState,
        show: true,
        message: "Trying to connect...",
        type: "Error",
      }));
      setTimeout(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: false,
        }));
      }, 9000);
    });
    scenarioExe(data, token)
      .then((response) => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("سناریو با موفقیت اجرا شد."),
          type: "Success",
          request: "",
          question: "",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 2000);
      })
      .catch((error) => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
          type: "Error",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 2000);
      });
  };
  const handleScenarioDelete = () => {
    setShowAlert((prevState) => ({
      ...prevState,
      show: true,
      message: t("آیا از حذف سناریوی ") + t(`${title}`) + t("اطمینان دارید؟"),
      type: "Warning",
      question: true,
      request: "deleteScenario",
    }));
  };
  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var formdata = new FormData();
    formdata.append("scenario_id", uid);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://assessn.mmaviot.com/api/scenariowgapp_list", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let z = JSON.parse(result);
        setScenarioCommand(z.data);
      })
      .catch((error) => {
        if (error.response.status === 403) {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t(" خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  }, []);

  return (
    <>
      <ModalComp
        modal={openAddScenarioModal}
        toggle={toggleAddScenario}
        component={
          <AddScenario
            titleEdit={title}
            iconEdit={icon}
            uid={uid}
            submit={submitScenarioEdit}
            setOpenAddScenarioModal={setOpenAddScenarioModal}
            closeModal={closeModal}
            scenarioCommandEdit={scenarioCommand}
            setScenarioCommandEdit={setScenarioCommand}
          />
        }
      />
      <div className="bg-gray" style={{ minHeight: "80vh" }}>
        <div className="d-flex align-items-center flex-column">
          <i className="circleTop  text-center">
            <i className={`${icon} d-block`}></i>
          </i>
          <div className="text-center mt-2">
            <p className="m-0">{t("سناریو")}</p>
            <p className="fn12 ">{title}</p>
          </div>
        </div>
        <div
          className="w-100 text-right borderBottom mb-3 cursor"
          onClick={handleScenarioExe}
        >
          <p className="fn">{t("اجرا")}</p>
        </div>
        <div
          className="w-100 text-right borderBottom mb-3 cursor"
          onClick={toggleAddScenario}
        >
          <p className="fn">{t("ویرایش")}</p>
        </div>
        <div
          className="w-100 text-right borderBottom mb-3 cursor"
          onClick={handleScenarioDelete}
        >
          <p className="fn"> {t("حذف")}</p>
        </div>

        {showAlert.show && (
          <Alert
            message={showAlert.message}
            type={showAlert.type}
            question={showAlert.question}
            id={uid}
            toggleAlert={toggleAlert}
            request={showAlert.request}
            closeModal={closeModal}
            setOpenAddScenarioModal={setOpenAddScenarioModal}
            toggleAddScenario={toggleAddScenario}
          />
        )}
      </div>
    </>
  );
};
export { ScenariosModal };
